// extracted by mini-css-extract-plugin
export default {"page":"Fixtures_page__Kp4g1","container":"Fixtures_container__GQA9j","title":"Fixtures_title__WJzTx","content":"Fixtures_content__3VSfU"};